// extracted by mini-css-extract-plugin
module.exports = {"location":"bC_dy","locationCity":"bC_fb","locationContent":"bC_fc"};